export enum UploadStatus {
  Pending = 'Pending',
  Uploading = 'Uploading',
  Uploaded = 'Uploaded',
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  ZipPending = 'ZipPending',
  Authorising = 'Authorising',
  FailedAuthorisation = 'FailedAuthorisation',
  Initializing = 'Initializing'
}